export const MODULE_GROUP = 'ModuleGroup';
/** Max nesting depth for `parentGroupId` chains (sanity guard). Spec 0038 §3.3. */
export const MAX_GROUP_DEPTH = 5;
//# sourceMappingURL=moduleGroup.js.map